/* tslint:disable */
import {
  Institutions
} from '../index';

declare var Object: any;
export interface AccountIncomeSourceInterface {
  "source": string;
  "description"?: string;
  "amount": string;
  "financial_year": string;
  "institution_id": number;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  institutions?: Institutions;
}

export class AccountIncomeSource implements AccountIncomeSourceInterface {
  "source": string;
  "description": string;
  "amount": string;
  "financial_year": string;
  "institution_id": number;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  institutions: Institutions;
  constructor(data?: AccountIncomeSourceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `AccountIncomeSource`.
   */
  public static getModelName() {
    return "AccountIncomeSource";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of AccountIncomeSource for dynamic purposes.
  **/
  public static factory(data: AccountIncomeSourceInterface): AccountIncomeSource{
    return new AccountIncomeSource(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'AccountIncomeSource',
      plural: 'AccountIncomeSources',
      path: 'AccountIncomeSources',
      properties: {
        "source": {
          name: 'source',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "amount": {
          name: 'amount',
          type: 'string'
        },
        "financial_year": {
          name: 'financial_year',
          type: 'string'
        },
        "institution_id": {
          name: 'institution_id',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        institutions: {
          name: 'institutions',
          type: 'Institutions',
          model: 'Institutions'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/AccountIncomeSource.ts